import { minifyGraphQL } from '@/lib/helper/minifyGraphql';
import { cropMediaFragment } from './cropMediaFragment';
import { menuFragment } from './menuFragment';

export const pageFragment =
  minifyGraphQL(`Pages(where: $where, locale: $locale) {
    docs {
      id
      name
      slug
      pageLayout {
        name
        identifier
      }
      metadata {
      subTypes
        topic {
          title
          description
          id
          parentTopic {
            name
            id
          }
        }
      }
      pageLayoutIdentifier
      sections {
        isEnabled
        name
        blocks {
          id
          name
          blockLabel
          redirectUrl
          actionButtonLabel
          backgroundColor
          blockElements {
            type
            subTypes
            id
            title
            backgroundColor
            topics {
              id
              title
            }
            podcastsFilter{
              id
            }
            tags
            dateFilter
            dateFromFilter
            dateToFilter
            filterContentBy
            coverMedia {
              media{
                ${cropMediaFragment}
              }
              }
            tvShow {
                id
                title
                description
                coverImage{
                  ${cropMediaFragment}
                }
            }
            content {
              status
              id
              description
              title
              type
              subType
              slug
              coverMedia 
              coverImage 
              media 
              tvShow {
                id
                title
                description
                coverImage{
                  ${cropMediaFragment}
                }
            }
              audioNarration
              duration
              readingTime {
                text
                minutes
              }
              primaryTopics {
                id
                title
                page {
                 name
                 slug
                }
              }
              author{
                id_
                name
                profileUrl
                profilePicture {
                  url
                  type
                  caption
                  thumbnailUrl
                }
              }
              otherAuthors {
              id_
                name
                profileUrl
                profilePicture {
                  url
                  type
                  caption
                  thumbnailUrl
                }
                  }
              backgroundColor
              websiteBlockDetails
            }
            isPinned
            liveStream {
               streamUrl
                title
                type
                createdAt
                description
                epgUrl
            }
            liveCoverage {
              status  
              id
              title
              description
              updatedAt
              details
              mainHeadline
              media {
                ${cropMediaFragment}
              }
            }
            
          }
          blockLayoutIdentifier
          blockLayout {
            name
            identifier
          }
        }
        sectionLayoutIdentifier
      }
      supportedPageLayouts
      order
      description
    ${menuFragment}
    }
    hasNextPage
    hasPrevPage
    limit
    offset
    page
    pagingCounter
    totalDocs
    totalPages
  }`);
